export default __webpack_public_path__ + "static/media/Processifyd.8034add5e5adb0779150b1bddfbbce76.webp";